import api from ".";
import { getToken } from "../Auth/Token";


export const getIngredients = async () => {
  try {
    const token = getToken();

    const [resProducts, resNamings] = await Promise.all([
      api.get("/api/products/vrac-spices-blends", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      api.get("/api/ingredients/namings", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }).catch(() => ({ data: {} })),
    ]);

    const namings = Array.isArray(resNamings.data?.ingredientNamings)
      ? resNamings.data.ingredientNamings
      : Array.isArray(resNamings.data)
      ? resNamings.data
      : [];

    const namingPriceMap = new Map();
    namings.forEach((item) => {
      const skuKey = String(item.sku || "").trim();
      const cost = Number(item.unitCost) || 0;
      if (skuKey && cost > 0) {
        namingPriceMap.set(skuKey, cost);
      }
    });

    return (resProducts.data?.products || []).map((p) => {
      const skuKey = String(p.sku || "").trim();
      const productCost = Number(p.suppliers?.purchasePrice) || 0;
      const finalCost = productCost > 0 ? productCost : (namingPriceMap.get(skuKey) || 0);

      return {
        _mongoId: p._id,
        sku: p.sku,
        name: p.description || "",
        nameFr: p.customFields?.nameFr || "",
        unitCost: finalCost,
        uom: p.uom || "kg",
      };
    });
  } catch (error) {
    console.error("Get Ingredients API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const getIngredientNamings = async (params = {}) => {
  try {
    const token = getToken();
    const res = await api.get("/api/ingredients/namings", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const records = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data?.records)
          ? res.data.records
          : Array.isArray(res.data?.namings)
            ? res.data.namings
            : Array.isArray(res.data?.ingredientNamings)
              ? res.data.ingredientNamings
              : [];

    return records.map((record) => ({
      ...record,
      sku: record.sku || record.SKU || "",
      nameEn: record.nameEn || record.name_en || record.englishName || "",
      nameFr: record.nameFr || record.name_fr || record.frenchName || "",
      unitCost: record.unitCost !== undefined && record.unitCost !== null && record.unitCost !== ""
        ? Number(record.unitCost)
        : Number(record.suppliers?.purchasePrice || 0),
      ingredientListEn:
        record.ingredientListEn ||
        record.ingredient_list_en ||
        record.ingredientsEn ||
        record.ingredients ||
        "",
      ingredientListFr:
        record.ingredientListFr ||
        record.ingredient_list_fr ||
        record.ingredientsFr ||
        record["ingrédients"] ||
        "",
    }));
  } catch (error) {
    console.error("Get Ingredient Namings API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};



export const updateIngredient = async (data) => {
  try {
    const token = getToken();
    console.log("UPDATE DATA:", data);
    console.log("PUT URL:", `/api/products/vrac-spices-blends/${data.sku}`);
    let resData = null;

    // 1. Update ERPAG / DetailedSkuProduct catalog (if present)
    try {
      const res = await api.put(
        `/api/products/vrac-spices-blends/${data.sku}`,
        {
          description: data.name || data.nameEn || "",
          customFields: {
            nameEn: data.name || data.nameEn || "",
            nameFr: data.nameFr || "",
          },
          suppliers: { purchasePrice: Number(data.unitCost) || 0 },
          uom: data.uom || "kg",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      resData = res.data;
    } catch (catalogErr) {
      console.warn("Catalog product update skipped or failed:", catalogErr?.response?.data?.message || catalogErr.message);
    }

    // 2. Sync with MongoDB IngredientNaming database
    try {
      const namingRes = await api.put(
        `/api/ingredients/namings/${data.sku}`,
        {
          nameEn: data.name || data.nameEn || "",
          nameFr: data.nameFr || "",
          ingredientListEn: data.ingredientListEn || "",
          ingredientListFr: data.ingredientListFr || "",
          unitCost: Number(data.unitCost) || 0,
          uom: data.uom || "kg",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!resData) resData = namingRes.data;
    } catch (err) {
      console.error("Failed to sync ingredient naming collection:", err);
    }

    return resData || { success: true };
  } catch (error) {
    console.error("Update Ingredient API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const createIngredient = async (data) => {
  try {
    const token = getToken();

    const res = await api.post(
      `/api/products/vrac-spices-blends`,
      {
        sku: data.sku,
        description: data.name,
        uom: data.uom || "kg",
        suppliers: { purchasePrice: Number(data.unitCost) || 0 },
        customFields: {
          nameEn: data.name || "",
          nameFr: data.nameFr || "",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Create Ingredient API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
export const deleteIngredient = async (sku) => {
  try {
    const token = getToken();

    const res = await api.delete(
      `/api/products/vrac-spices-blends/${sku}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("Delete Ingredient API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};


export const getPackagingItems = async () => {
  try {
    const token = getToken();

    const res = await api.get(
      "/api/products/packaging-items",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return (res.data.products || []).map((p) => ({
      sku: p.sku,
      name: p.description || p.customFields?.nameEn || "",
      unitCost: p.suppliers?.purchasePrice || 0,
      unitCostSource: "erpag",
      uom: p.uom || "unit",
    }));
  } catch (error) {
    console.error("Get Packaging Items API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
